import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { ReportLogService } from "src/app/services/report-log.service";
import { TravelerService } from "src/app/services/traveler.service";
import { UtilityService } from "src/app/services/utility.service";

@Component({
  selector: "app-report-log-deleted-traveler",
  templateUrl: "./report-log-deleted-traveler.component.html",
  styleUrls: ["./report-log-deleted-traveler.component.css"],
})
export class ReportLogDeletedTravelerComponent implements OnInit {
  model: any = {};
  yearList: any = [];
  tripOptionList = [];
  alltripList = [];
  years = "";
  tripId = "";
  searchText = "";

  public displayedColumns = [
    //'deletedOnDisplay',
    "formattedDate",
    "formattedTime",
    "deletedByName",
    "tripCode",
    "ppeWhsCode",
    "salesmanCode",
    "customerNumber",
    "companyName",
    "groups",
    "legalName",
    "gender",
    "nickName",
    "dateOfBirth",
    "cellPhone",
    "emailAddress",
    "miscGroupRequest",
    "rentACar",
    "wheelChairRequest",
  ];

  public dataSource = new MatTableDataSource<DeletedTravelerEntity>();
  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: true })
  sort: MatSort;
  response: any = {};
  constructor(
    private travelerService: TravelerService,
    public _utilityService: UtilityService,
    private reportLogService: ReportLogService
  ) {}

  ngOnInit() {
    this.yearList = this._utilityService.fillYear(
      new Date().getFullYear() - 3,
      new Date().getFullYear() + 1
    );
    this.travelerService.getTripCodeList().subscribe((result) => {
      this.alltripList = result;
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  deletedTravelerList() {
    this.dataSource.data = [];
    if (+this.tripId > 0 && +this.years > 0) {
      this.reportLogService
        .getDeletedTravelerList(this.years, this.tripId)
        .subscribe((result) => {
          this.model = this.dataSource.data = result as DeletedTravelerEntity[];
          this.dataSource.paginator = this.paginator;
        });
    }
  }

  changeYear() {
    this.tripId = "";
    this.tripOptionList = [];
    if (this.alltripList && this.alltripList.length > 0)
      this.tripOptionList = this.alltripList.filter(
        (t) => t.years === this.years
      );
    this.dataSource.data = [];
  }

  changeTrip() {
    this.deletedTravelerList();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.searchText = filterValue;
    this.dataSource.filter = filterValue;
  }
}

export interface DeletedTravelerEntity {
  id: number;
  enrollmentId: number;
  deletedOnDisplay: string;
  deletedByName: string;
  tripCode: string;
  ppeWhsCode: string;
  salesmanCode: string;
  customerNumber: string;
  companyName: string;
  groups: number;
  legalName: string;
  gender: number;
  nickName: string;
  dateOfBirth: string;
  cellPhone: string;
  emailAddress: string;
  miscGroupRequest: string;
  rentACar: boolean;
  wheelChairRequest: boolean;
  formattedDate: string;
  formattedTime: string;
}
